export const FRONT_TUG_SUMMARY_V1 = "/front-tug-reportv1";
export const FRONT_TUG_SUMMARY_V2 = "/front-tug-reportv2";
export const FRONT_TUG_HISTORY = "/front-tug-history";
export const FRONT_TUG_METRIC_TREND = "/front-tug-metric-trend";
export const SIDE_TUG_SUMMARY_V2 = "/side-tug-reportv2";
export const SIDE_TUG_HISTORY = "/side-tug-history";
export const SIDE_TUG_METRIC_TREND = "/side-tug-metric-trend";
export const FRONT_TUG_V2_PDF = "/front-tug-reportv2pdf";
export const SIDE_TUG_V2_PDF = "/side-tug-reportv2pdf";
